"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContextMenu_meta_1 = require("../ContextMenu.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY, ['dropdown']);